<template>
    <b-modal id="createModal" size="md" body-class="px-0" ref="modal" title="Create a User" v-model="show" @ok="handleSubmit" @hide="close"
             @shown="focusNameInput">

        <div class="card card-flat mb-0">
            <div class="bg-light">
                <h6 class="card-header text-secondary">Account Details</h6>
            </div>
            <div class="card-body">

                <div class="form-group">
                    <label for="nameInput">Your Name</label>
                    <div class="position-relative">
                        <input type="text" id="nameInput" ref="nameInput" name="name" v-validate="validation.name" v-model="name"
                               placeholder="Your Name" class="form-control" required>
                        <div class="invalid-feedback" v-if="errors.has('name')">{{ errors.first('name') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="form-group">
                    <label for="emailInput">Email Address</label>
                    <div class="position-relative">
                        <input type="email" id="emailInput" name="email" v-validate="validation.email" v-model="email"
                               placeholder="Email Address" class="form-control">
                        <div class="invalid-feedback" v-if="errors.has('email')">{{ errors.first('email') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="form-group">
                    <label for="emailInput">Password</label>
                    <div class="position-relative">
                        <input type="password" id="passwordInput" name="password" v-validate="validation.password" v-model="password"
                               placeholder="Password" class="form-control">
                        <div class="invalid-feedback" v-if="errors.has('password')">{{ errors.first('password') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>

                <div class="form-group">
                    <label>Role</label>
                    <div class="position-relative">
                        <VueSelect
                                v-validate="validation.role"
                                data-vv-name="role"
                                v-model="role"
                                :options="allRoles"
                                :allow-empty="false"
                                deselect-label=""
                                placeholder="Role"
                                label="title"
                                track-by="id"
                        >
                        </VueSelect>
                        <div class="invalid-feedback" v-if="errors.has('role')">{{ errors.first('role') }}</div>
                        <i class="form-group__bar"></i>
                    </div>
                </div>
            </div>

            <div class="card card-flat mb-0" v-if="role">
                <div class="bg-light">
                    <h6 class="card-header text-secondary">{{ role.title }} details</h6>
                </div>
                <div class="card-body">
                    <div class="form-group" v-if="hasBusinessName">
                        <label for="nameInput">Business Name</label>
                        <div class="position-relative">
                            <input type="text" id="businessNameInput" name="business_name" v-validate="validation.business_name" v-model="business_name"
                                   placeholder="Business Name" data-vv-as="business name" class="form-control" required>
                            <div class="invalid-feedback" v-if="errors.has('business_name')">{{ errors.first('business_name') }}</div>
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="form-group" v-if="isA('processor')">
                        <label>Represented Processor</label>
                        <div class="position-relative">
                            <VueSelect
                                    v-model="managedProcessor"
                                    :options="allProcessors"
                                    placeholder="Represented Processor"
                                    label="name"
                                    track-by="id"
                            >
                            </VueSelect>
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="form-group" v-if="isA('association')">
                        <label>Represented Association</label>
                        <div class="position-relative">
                            <VueSelect
                                    v-model="managedAssociation"
                                    :options="allAssociations"
                                    placeholder="Represented Association"
                                    label="name"
                                    track-by="id"
                            >
                            </VueSelect>
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="form-group" v-if="isA('grower', 'contractor')">
                        <label>Region</label>
                        <div class="position-relative">
                            <VueSelect
                                    v-validate="validation.region"
                                    data-vv-name="region"
                                    v-model="region"
                                    :options="allCountries"
                                    :allow-empty="false"
                                    deselect-label=""
                                    placeholder="Region"
                                    group-values="regions"
                                    group-label="name"
                                    label="name"
                                    track-by="id"
                            >
                            </VueSelect>
                            <div class="invalid-feedback" v-if="errors.has('region')">{{ errors.first('region') }}</div>
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div class="form-group " v-if="isA('grower')">
                        <label for="physicalAddressInput">Physical Address</label>
                        <div class="position-relative">
                        <textarea id="physicalAddressInput" name="physical_address" v-model="physical_address"
                                  placeholder="Physical Address" class="form-control" v-autosize></textarea>
                            <i class="form-group__bar"></i>
                        </div>
                    </div>

                    <div v-if="isA('auditor', 'admin', 'developer')" class="text-secondary text-center">
                        No options available for this role
                    </div>
                </div>
            </div>

        </div>
        <template slot="modal-footer">
            <button class="btn btn-secondary" @click="close">
                Cancel
            </button>
            <button class="btn btn-primary" @click="handleSubmit">
                Save
            </button>
        </template>
    </b-modal>
</template>


<script>
import createUserMutation from '@views/Users/CreateModal/mutationCreateUser.graphql';
import listAssociationsQuery from '@views/Users/CreateModal/queryListAssociations.graphql';
import listCountriesQuery from '@views/Users/CreateModal/queryListCountries.graphql';
import listProcessorsQuery from '@views/Users/CreateModal/queryListProcessors.graphql';
import listRolesQuery from '@views/Users/CreateModal/queryListRoles.graphql';
import listUserQuery from '@views/Users/queryListUsers.graphql';

export default {
  name: 'create-modal',
  apollo: {
    allCountries: {
      query: listCountriesQuery,
      update: data => data.filterCountries.data,
    },
    allProcessors: {
      query: listProcessorsQuery,
      update: data => data.filterProcessors.data,
      skip() {
        return (!this.role) || this.role.name !== 'processor';
      },
    },
    allAssociations: {
      query: listAssociationsQuery,
      update: data => data.filterAssociations.data,
      skip() {
        return (!this.role) || this.role.name !== 'association';
      },
    },
    allRoles: {
      query: listRolesQuery,
      update: data => data.filterRoles,
    },
  },
  props: {
    close: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      loading: 0,
      id: null,
      show: true,
      name: null,
      business_name: null,
      physical_address: null,
      email: null,
      password: null,
      region: null,
      role: null,
      managedProcessor: null,
      managedAssociation: null,
      allCountries: [],
      allRoles: [],
      allProcessors: [],
      allAssociations: [],
      validation: {
        name: { required: true },
        role: { required: true },
        password: { required: true },
        region: { required: true },
        email: { required: true, email: true },
      },
    };
  },
  computed: {
    hasBusinessName() {
      return !this.isA('processor', 'association')
    },
  },
  methods: {
    isA(...roles) {
      return this.role && roles.includes(this.role.name);
    },
    handleSubmit() {
      this.errors.remove('global');
      this.$validator.validateAll().then(validationWasSuccessful => {
        if (!validationWasSuccessful) {
          return;
        }
        const mutationInput = {
          name: this.name,
          business_name: this.business_name,
          email: this.email,
          password: this.password,
          role_id: this.role.id,
        };

        if (this.isA('grower', 'contractor')) {
          mutationInput.region_id = this.$path.get(this, 'region.id');
        }

        if (this.isA('processor')) {
          mutationInput.managed_processor_id = this.$path.get(this, 'managedProcessor.id');
        }

        if (this.isA('association')) {
          mutationInput.managed_association_id = this.$path.get(this, 'managedAssociation.id');
        }

        if (this.isA('grower')) {
          mutationInput.physical_address = this.physical_address;
        }

        if(this.hasBusinessName) {
          mutationInput.business_name = this.business_name;
        }

        this.$apollo
          .mutate({
            mutation: createUserMutation,
            refetchQueries: [
              { query: listUserQuery, variables: { input: { include_deleted: true } } },
              { query: listUserQuery },
            ],
            variables: {
              input: mutationInput,
            },
          })
          .then(() => {
            this.$emit('refresh');
            this.$notifySuccess('User created!');
            this.close();
          })
          .catch(err => {
            this.$mapGraphQLError(err);
          })
          .catch(err => {
            console.error(err);
            this.$notifyFailure(
              'Unfortunately, we were unable to do that!',
            );
          });
      });
    },
    focusNameInput() {
      this.$refs.nameInput.focus();
    },
  },
};
</script>
